import { api } from "@/services/api"

type CreateTerminalWebAppAccessTokenResponse = {
  terminalWebAppAccessUrl: string
  expiresInSeconds: number
}

export const createTerminalWebAppAccessToken = async () => {
  const { body } =
    await api.post<CreateTerminalWebAppAccessTokenResponse>(
      "/terminal-web-app/create-access-token/"
    )

  return body
}
